import React from 'react';
import { Modal, Button } from 'antd';
import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';

const VARIANTS = {
  success: {
    gradient: 'linear-gradient(135deg, #15803d, #22c55e)',
    icon: <CheckCircleFilled style={{ color: '#fff', fontSize: 22 }} />,
    btnDanger: false,
    btnStyle: { background: '#15803d', borderColor: '#15803d' },
  },
  warning: {
    gradient: 'linear-gradient(135deg, #b45309, #f59e0b)',
    icon: <WarningFilled style={{ color: '#fff', fontSize: 22 }} />,
    btnDanger: false,
    btnStyle: { background: '#b45309', borderColor: '#b45309' },
  },
};

export default function SuccessAlertModal({
  visible,
  type = 'success',
  title,
  content,
  okText = 'OK',
  onClose,
  zIndex,
}) {
  const v = VARIANTS[type] || VARIANTS.success;

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      centered
      footer={null}
      closable={false}
      width="min(92vw, 420px)"
      bodyStyle={{ padding: 0 }}
      maskClosable
      zIndex={zIndex}
      className="success-alert-modal"
    >
      <style>{`
        .success-alert-modal .ant-modal-content {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 16px 48px rgba(0,0,0,0.2);
        }
      `}</style>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '22px 24px 18px', background: v.gradient }}>
        <div style={{
          width: 44, height: 44, borderRadius: '50%',
          background: 'rgba(255,255,255,0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          {v.icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#fff', lineHeight: 1.3 }}>
            {title}
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: '20px 24px 4px', color: '#374151', fontSize: 13.5, lineHeight: 1.6 }}>
        {content}
      </div>

      {/* Footer */}
      <div style={{ padding: '14px 24px 20px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type="primary"
          onClick={onClose}
          style={{ borderRadius: 8, fontWeight: 600, minWidth: 96, ...v.btnStyle }}
        >
          {okText}
        </Button>
      </div>
    </Modal>
  );
}
